import { useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { UncontrolledPopover } from 'reactstrap'
import { toast } from 'react-toastify'

import { reinviteCoach } from '../../actions/coachActions'
import { ReactComponent as EllipsisIcon } from '../../assets/images/common/icons/ellipsis-icon.svg'
import CoachContactInfoModal from './CoachContactInfoModal'
import EditCoachAccoladesModal from './EditCoachAccoladesModal'

import classes from './CoachActions.module.scss'

const CoachActions = ({ coach }) => {
  const [isContactInfoModalOpen, setIsContactInfoModalOpen] = useState(false)
  const [isEditAccoladesModalOpen, setIsEditAccoladesModalOpen] = useState(false)
  const [isReinviting, setIsReinviting] = useState(false)

  const handleReinviteCoach = () => {
    setIsReinviting(true)
    reinviteCoach(coach.id)
      .then(() => toast.success('Coach reinvitation sent successfully', { position: toast.POSITION.TOP_RIGHT }))
      .catch((_error) => {
        if (_error.response?.status === 503) {
          toast.error('Reinviting this coach is currently unavailable.', { position: toast.POSITION.TOP_RIGHT })
        } else {
          const errorMessage = _error.response.data.errors[Object.keys(_error.response.data.errors)[0]][0] ?? 'Something went wrong'
          toast.error(errorMessage, { position: toast.POSITION.TOP_RIGHT })
        }
      })
      .finally(() => setIsReinviting(false))
  }

  const handleViewContactInfo = () => {
    setIsContactInfoModalOpen(true)
  }

  const handleEditAccolades = () => {
    setIsEditAccoladesModalOpen(true)
  }

  return (
    <>
      <button
        id={`coach-actions-${coach.id}`}
        className={classNames(classes.coachActionsIcon, 'd-inline-flex', 'align-items-center', 'justify-content-center')}
        aria-label='More actions'
      >
        <EllipsisIcon className={classes.icon} />
      </button>

      {!isReinviting && !isContactInfoModalOpen && !isEditAccoladesModalOpen && (
        <UncontrolledPopover
          placement='bottom'
          target={`coach-actions-${coach.id}`}
          trigger='legacy'
          popperClassName='popover-style'
        >
          <div className={classNames('d-flex', 'flex-column', classes.coachActions)}>
            {coach.status === 'invited' ? (
              <button onClick={handleReinviteCoach} aria-hidden='true'>
                Reinvite
              </button>
            ) : (
              <button onClick={handleEditAccolades} aria-hidden='true'>
                Edit Accolades
              </button>
            )}
            <button onClick={handleViewContactInfo} aria-hidden='true'>
              View Contact Information
            </button>
          </div>
        </UncontrolledPopover>
      )}

      <CoachContactInfoModal
        isOpen={isContactInfoModalOpen}
        onClose={() => setIsContactInfoModalOpen(false)}
        coach={coach}
      />

      {isEditAccoladesModalOpen && (
        <EditCoachAccoladesModal
          isOpen={isEditAccoladesModalOpen}
          onClose={() => setIsEditAccoladesModalOpen(false)}
          coach={coach}
        />
      )}
    </>
  )
}

CoachActions.propTypes = {
  coach: PropTypes.shape({
    id: PropTypes.number.isRequired,
    status: PropTypes.string.isRequired,
  }).isRequired,
}

export default CoachActions
